<script lang="ts">
    import { sendUIInteractionAnalyticsEvent } from "@app/services/analytics/analytics-send-event";
    import { getCurrentDictionaryLabel } from "@app/services/currentDictionary.service";
    import AudioList from "./AudioList.svelte";
    import { playAudioFile } from "./AudioPlayerService";

    function setAudioListOpen(audioList: AudioList, open: boolean) {
        setTimeout(() => {
            audioList.$$set({ open });
        }, 1);
    }

    function initAudioListForContainer(container: HTMLElement) {
        const phrase = container.dataset["phrase"];
        const lang = container.dataset["lang"];
        const file = container.dataset["file"];
        const fileId = container.dataset["fileId"];
        console.log("Audio list container init", {
            phrase,
            lang,
            file,
            fileId,
        });

        if (phrase && lang) {
            if (file) {
                playAudioFile({ url: file, phrase, id: fileId });
            }
        } else {
            return;
        }

        let audioList: AudioList = (container as any).audioList;
        if (audioList) {
            setAudioListOpen(audioList, true);
            return;
        }
        function onClose() {
            setAudioListOpen(audioList, false);
            //button.parentElement.removeChild(div);
            sendUIInteractionAnalyticsEvent({
                action: "play-audio",
                label: "close",
            });
        }

        setTimeout(() => {
            // add element after processing this click event to prevent closing audios list
            const span = document.createElement("span");
            span.classList.add("md:relative");
            span.classList.add("inline-block");

            container.parentElement?.insertBefore(
                span,
                container.nextElementSibling,
            );
            audioList = new AudioList({
                target: span,
                props: {
                    onClose,
                    phrase,
                    lang,
                    autoplayFirstFile: !file,
                    autoplayFileId: fileId,
                    activatorElement: container,
                },
            });
            (container as any).audioList = audioList;
            setTimeout(() => {
                sendUIInteractionAnalyticsEvent({
                    action: "play-audio",
                    label: getCurrentDictionaryLabel(),
                });

                setAudioListOpen(audioList, true);
            });
        });
    }

    function handleAudioClick(event: Event) {
        const button = event.target as HTMLButtonElement;

        initAudioListForContainer(button);
    }

    document.addEventListener("click", (clickEvent: Event) => {
        const button = clickEvent.target as HTMLButtonElement;
        if (button instanceof HTMLButtonElement) {
            if (button.matches("button.glosbe-audio")) {
                handleAudioClick(clickEvent);
            }
        }
    });
</script>
